import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  Renderer2,
} from "@angular/core";

@Directive({
  selector: "[appScrollBlocker]",
  standalone: true,
})
export class ScrollBlockerDirective implements OnDestroy {
  private isBlocked = false;

  constructor(private renderer: Renderer2) {}
  

  @Input() set appScrollBlocker(isModalOpen: boolean) {
    this.isBlocked = isModalOpen;

    if (isModalOpen) {
      this.renderer.addClass(document.body, "modal-open");
    } else {
      this.renderer.removeClass(document.body, "modal-open");
    }
  }

  ngOnDestroy(): void {
    if (this.isBlocked) {
      this.renderer.removeClass(document.body, "modal-open");
    }
  }
}

